import { confirmDialog } from "primereact/confirmdialog";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useApproveRegistration } from "@domain/registration/new-registration/approve-registration.hook";
import { ApproveRegistrationFormSchema } from "@factory/form/form.rule";
import { GetRegistrationModel } from "@factory/model/query-model-registration";

export function useRegistrationActions() {
  const { showError, showSuccess } = useNotificationContext();
  const { mapApproveRegistration } = useFormApiMapper();
  const { approveRegistration, isCreating } = useApproveRegistration();

  const handleApproveDecline = (
    registration: GetRegistrationModel,
    status: "APPROVE" | "DECLINE",
    onSuccess?: (updatedRegistration: GetRegistrationModel) => void
  ) => {
    if (!registration?.code) {
      showError("No registration selected");
      return;
    }

    const message =
      status === "APPROVE"
        ? "Are you sure you want to approve this registration?"
        : "Are you sure you want to decline this registration?";

    confirmDialog({
      message,
      header: `${status === "APPROVE" ? "Approve" : "Decline"} Confirmation`,
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName:
        status === "APPROVE" ? "p-button-success" : "p-button-danger",
      accept: () => {
        const formData: ApproveRegistrationFormSchema = {
          code: registration.code!,
          status: status,
        };

        const approveRegistrationData = mapApproveRegistration(formData);

        approveRegistration(approveRegistrationData, {
          onSuccess: () => {
            showSuccess(`Registration ${status.toLowerCase()}d successfully`);
            onSuccess?.({ ...registration, status });
          },
          onError: (error: any) => {
            showError(
              `Failed to ${status.toLowerCase()} registration: ${error.message}`
            );
          },
        });
      },
    });
  };

  return {
    handleApproveDecline,
    isCreating,
  };
}
